import React from 'react'
import { motion } from "framer-motion";
import Banner from '../components/section/banner'
import MemberSection from '../components/section/members'
import SubBundle from '../components/section/SubBundle'

import WorkSection from '../components/section/workSection'
import StorySection from '../components/section/storySection'
import AppDownloadSection from '../components/section/appDownLoad'

const About = React.lazy(()=> import('../components/section/about'))
const home = () => {
  return (
    <>
     <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
    <Banner/>
    <MemberSection/>
    <SubBundle/>
    <About/>
    <WorkSection/>
    <StorySection/>
    <AppDownloadSection/>
    </motion.div>
    </>
  )
}

export default home
